module.exports = __webpack_public_path__ + "static/img/s29.cdb03515.png";